import { render, staticRenderFns } from "./bspdevreraporu.vue?vue&type=template&id=2d4d570f&scoped=true&"
import script from "./bspdevreraporu.vue?vue&type=script&lang=js&"
export * from "./bspdevreraporu.vue?vue&type=script&lang=js&"
import style0 from "./bspdevreraporu.vue?vue&type=style&index=0&id=2d4d570f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d570f",
  null
  
)

export default component.exports